import { lazy } from 'react';

export const PlayerMarketingEmailForm = lazy(
  () => import('./PlayerMarketingEmailForm'),
);
